import {
    Alert,
    AlertTitle,
    Box,
    Button,
    styled,
    Typography,
} from '@mui/material';
import React from 'react';
import { Link, Redirect } from 'react-router-dom';

const LinkColor = styled(Link)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&:hover': {
        color: theme.palette.secondary.main,
        'text-decoration': 'none',
    },
}));

const ProfileWarning = props => {
    return (
        <Box sx={{ m: 2 }}>
            <Typography sx={{ m: 2 }} variant="h1">
                Verification Required
            </Typography>
            <Alert severity="warning" sx={{ padding: '20px 40px' }}>
                <Box sx={{ m: 1 }}>
                    <AlertTitle>Warning</AlertTitle>
                    {props.message} —{' '}
                    <strong>Finish setting up your Profile</strong>
                </Box>
                <Box sx={{ m: 1 }}>
                    To use the application you need to be verified as a Teacher.
                </Box>
                <LinkColor to="/profile/skills">
                    <Button color="secondary" variant="outlined">
                        Profile Page
                    </Button>
                </LinkColor>
            </Alert>
            <Typography sx={{ m: 2 }} variant="h4">
                Redirecting in {props.redirectTime} Seconds
            </Typography>

            <Typography sx={{ m: 2 }}>
                Please ensure you have viewed your profile and all your
                information is correct and up to date.
            </Typography>
            {props.redirectTime === 0 && <Redirect to="/profile/userInfo" />}
        </Box>
    );
};

export default ProfileWarning;
